module.exports = __webpack_public_path__ + "img/moishop_portfolio_4_2x.3bab96d5.png";